import { AuthResponseCode } from '../../constants/auth-response-code.enum';
import { ForgotPasswordService } from '../forgot-password.service';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { RequestPasswordReset } from '../models/request-password-reset.model';

@Component({
  selector: 'app-reset-email-sent',
  templateUrl: './reset-email-sent.component.html',
  styleUrls: ['./reset-email-sent.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResetEmailSentComponent {
  @Input() public email: string;
  @Input() public isResendEnabled = true;
  @Output() public emailSent = new EventEmitter<RequestPasswordReset>();

  public errorMessage: string;
  public isSending = false;

  constructor(private forgotPasswordService: ForgotPasswordService) { }

  async resend() {
    if (this.isSending || !this.isResendEnabled) {
      return;
    }

    this.isSending = true;

    try {
      const model: RequestPasswordReset = {
        email: this.email,
      };

      const response = await this.forgotPasswordService.requestPasswordReset(model);

      switch(response) {
        case AuthResponseCode.PASSWORD_RESET_EMAIL_SENT:
          this.emailSent.emit(model);
          break;
        default:
          this.errorMessage = "An error occurred. Please try again.";
          break;
      }
    } catch(error) {
      this.errorMessage = "An error occurred. Please try again.";
    } finally {
      this.isSending = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/reset-email-sent/reset-email-sent.component.ts